import React, { type ReactNode, Fragment } from "react";

type Item = {
  title: string;
  items?: string[];
};

export const AlertList = ({
  items,
  title,
}: {
  title: ReactNode;
  items: Item[];
}) => {
  return (
    <div>
      {title}
      <ul
        css={{
          padding: "0px",
          paddingLeft: "14px",
        }}
      >
        {items.map((item, index) => (
          <Fragment key={index}>
            <li>{item.title}</li>
            {item.items && <SubList items={item.items} />}
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

const SubList = ({ items }: { items: string[] }) => {
  return (
    <div>
      <ul
        css={{
          padding: "0px",
          paddingLeft: "14px",
        }}
      >
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};
